import keyMirror from 'keymirror';

import { SCREEN_SIZES } from '@/shared/Constants';

export const freePlayActionTypes = keyMirror({
	GET_CATEGORIES_REQUEST: null,
	GET_CATEGORIES_SUCCESS: null,
	GET_CATEGORIES_ERROR: null,

	GET_CATEGORY_REQUEST: null,
	GET_CATEGORY_SUCCESS: null,
	GET_CATEGORY_ERROR: null,

	GET_LEVEL_REQUEST: null,
	GET_LEVEL_SUCCESS: null,
	GET_LEVEL_ERROR: null,

	RESET_CATEGORY: null,
	SET_LEVEL_PROGRESS: null,
	SET_SHOW_ENTRANCE_ANIMATION: null,

	SET_OPEN_FINISHED_FIRST_QUESTION_SET_SURVEY: null,
});

export const viewIndexCount = 3;

export enum CategorySectionsEnum {
	LOCKED_CHALLENGES = 0,
	ACTIVE_CHALLENGE = 1,
	COMPLETED_CHALLENGES = 2,
	INFINITY_COMPLETED_CHALLENGES = 1,
}

export const achievementScaleMap = {
	[SCREEN_SIZES.MOBILE]: [7, 3, 4],
	[SCREEN_SIZES.TABLET]: [10, 5, 6],
	[SCREEN_SIZES.DESKTOP]: [15, 8, 9],
};

export const maxCompletedChallenges = 8;

export const maxLockedChallenges = 3;
